export const formatMessage = (messageData, currentUserId) => {
    const isSentByMe = messageData.sender_id === currentUserId;
    
    return {
        id: messageData.id || Date.now(), // Use server ID or fallback to timestamp
        name: isSentByMe ? "You" : messageData.sender_name,
        role: messageData.sender_role,
        time: new Date(messageData.created_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
        created_at: messageData.created_at || new Date().toISOString(),
        messages: messageData.message ? [messageData.message] : [],
        type: isSentByMe ? 0 : 1, // 1 for sent by you, 0 for received
        message_type: messageData.message_type || (messageData.attachments?.length ? "media" : "text"),
        media_url: messageData.media_url,
        is_read: messageData.is_read,
        attachments: messageData.attachments || []
    };
};